<template>
  <div class="pointer" @click="OrderUp()">
    <img src="@/assets/images/elements/iconUp.svg" alt="" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../../util/backend";
import baseUrl from "../../../../util/baseUrl";

export default {
  computed: {
    ...mapGetters({
      pointer: "general/pointer"
    })
  },

  methods: {
    async OrderUp() {
      let config;
      switch (this.pointer) {
        case "video":
          config = {
            method: "put",
            url: `${baseUrl.baseurl()}/VideoOrderUp`,
            data: {
              video_id: this.params.value
            }
          };
          console.log(config);
          await axios.api(config).then(async res => {
            res.status === 200
              ? await this.$store.dispatch(
                  "general/getCourseDetail",
                  this.$route.params.id
                )
              : alert("order fail");
          });
          break;

        case "banner":
          config = {
            method: "put",
            url: `${baseUrl.baseurl()}/bannerOrderUp`,
            data: {
              banner_id: this.params.value
            }
          };
          console.log(config);
          await axios.api(config).then(async res => {
            res.status === 200
              ? await this.$store.dispatch("general/get_bannerTable")
              : alert("order fail");
          });
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
